export enum ENavigationRoute {

    Login = 'login',
    Error = 'error',

    WeeklyList = 'weekly-list',
    InterventionList = 'intervention-list',
    Intervention = 'intervention',
    ZoneMeasure = 'zone-measure',
    ProcessMeasure = 'process-measure',
    MassifMeasure = 'massif-measure',
    EauMeasure = 'eau-measure',
    LingetteMeasure = 'lingette-measure',
    DrawingTool = 'drawing-tool',
    Pointage = 'pointage',
    Scan = 'scan',
    Metrologie = 'metrologie',
    Adduction = 'adduction',
    Generics = "generics",
}

